import axios from 'axios';

export default {
    namespaced: true,
    state: {
        listing: {
            title: null,
            brand: null,
            description: null,
            categoryId: null,
            dailyRate: null,
            deposit: null,
            renterPickup: false,
            ownerDelivery: false,
            tooliabaDelivery: false,
            deliveryPrice: null,
            fees: [],
            rates: [],
            files: [],
            tags: []
        },
        suggestedCategories: null,
        loadingSuggestedCategories: false,
        allCategories: null
    },
    mutations: {
        resetListing(state) {
            state.listing = {
                title: null,
                brand: null,
                description: null,
                categoryId: null,
                dailyRate: null,
                deposit: null,
                deliveryPrice: null,
                renterPickup: false,
                ownerDelivery: false,
                tooliabaDelivery: false,
                fees: [],
                rates: [],
                files: [],
                tags: [],
                deliveryOptions: []
            };
            state.suggestedCategories = null;
        },
        setTitle(state, title) {
            state.listing.title = title;
        },
        setBrand(state, brand) {
            state.listing.brand = brand;
        },
        setDescription(state, description) {
            state.listing.description = description;
        },
        setCategoryId(state, categoryId) {
            state.listing.categoryId = categoryId;
        },
        setFees(state, fees) {
            state.listing.fees = fees;
        },
        setRates(state, { dailyRate, rates }) {
            state.listing.dailyRate = dailyRate;
            state.listing.rates = rates;
        },
        setTags(state, tags) {
            state.listing.tags = tags;
        },
        setDeliveryOptions(state, deliveryOptions) {
            state.listing.renterPickup = deliveryOptions.renterPickup;
            state.listing.ownerDelivery = deliveryOptions.ownerDelivery;
            state.listing.tooliabaDelivery = deliveryOptions.tooliabaDelivery;
        },
        setDeposit(state, deposit) {
            state.listing.deposit = deposit;
        },
        setDeliveryPrice(state, deliveryPrice) {
            state.listing.deliveryPrice = deliveryPrice;
        },
        updateSuggestedCategories(state, data) {
            state.suggestedCategories = data;
            state.loadingSuggestedCategories = false;
        },
        updateAllCategories(state, data) {
            state.allCategories = data;
        },
        addFiles(state, files) {
            var reader = new FileReader();

            reader.onloadend = () => {
                state.listing.files.push(reader.result);
            };

            Array.from(files).forEach(file => {
                reader.readAsDataURL(file);
            });
        },
        removeFile(state, index) {
            state.listing.files.splice(index, 1);
        },
        loadSuggestedCategories(state) {
            state.loadingSuggestedCategories = true;
        }
    },
    actions: {
        setTitle({ commit, state }, title) {
            commit('setTitle', title);
            commit('loadSuggestedCategories');
            axios
                .get('/listing-categories?q=' + title)
                .then(result => {
                    commit('updateSuggestedCategories', result.data.data);
                })
                .catch(console.error);

            if (!state.allCategories) {
                axios
                    .get('/listing-categories?root=true')
                    .then(result => {
                        commit('updateAllCategories', result.data.data);
                    })
                    .catch(console.error);
            }
        },
        postListing({ state }) {
            return axios.post('/listing', state.listing).catch(console.error);
        }
    }
};
